<template>
  <van-action-sheet v-model="visible" :closeable="false" @closed="onClosed">
    <div class="sheet" :class="themeClass">
      <template v-if="visibleEmailInput">
        <div class="sheet-form">
          <p class="sheet-form-title">{{ languages.emailRemind }}</p>
          <p class="sheet-form-tip">{{ languages.serviceWillReply }}</p>
          <van-form class="sheet-form-main">
            <van-field
              class="sheet-form-item"
              v-model="workEmail"
              @input="getInputEmail"
              :clearable="true"
              name="workEmail"
              :placeholder="languages.inputValidEmail"
            />
            <van-button
              block
              type="info"
              native-type="submit"
              class="sheet-form-submit"
              @click="beforeSubmit"
            >
              {{ languages.submit }}
            </van-button>
          </van-form>
        </div>
      </template>
      <template v-else-if="visibleEmailConfirm">
        <div class="sheet-email">
          <div class="sheet-email-top">
            <p>{{ languages.reconfirmEmail }}</p>
            <p class="email">{{ email || workEmail }}</p>
            <p>{{ submitTip }}</p>
          </div>
          <div class="sheet-email-bottom">
            <van-button
              class="cancel"
              @click="email ? close() : showEmailInput()"
            >
              {{ languages.no }}
            </van-button>
            <van-button
              class="confirm"
              @click="submit"
              :loading="loadingSubmit"
            >
              {{ languages.yes }}
            </van-button>
          </div>
        </div>
      </template>
      <template v-else-if="visibleEmailUnSubscribe">
        <div class="sheet-email">
          <div class="sheet-email-top">
            <p>&nbsp</p>
            <p>{{ languages.isCancelEmailRemind }}</p>
            <p class="email">{{ email }}</p>
          </div>
          <div class="sheet-email-bottom">
            <van-button class="cancel" @click="onClosed">
              {{ languages.no }}
            </van-button>
            <van-button
              class="confirm"
              @click="submit"
              :loading="loadingSubmit"
            >
              {{ languages.yes }}
            </van-button>
          </div>
        </div>
      </template>
      <template v-else-if="visibleEmailSubscribeSucc">
        <div class="sheet-success">
          <span class="sheet-success-icon">
            <em class="iconfont icon-gou"></em>
          </span>
          <p class="sheet-success-text">
            {{ submitSuccessTip || languages.submitSuccess }}
          </p>
        </div>
      </template>
      <template v-else-if="visibleEmailUnSubscribeSucc">
        <div class="sheet-success">
          <span class="sheet-success-icon">
            <em class="iconfont icon-gou"></em>
          </span>
          <p class="sheet-success-text">
            {{ languages.reRemindEmail }}
          </p>
        </div>
      </template>
    </div>
  </van-action-sheet>
</template>

<script>
import { mapState } from 'vuex';
import globalConfig from '@utiles/globalConfig';
import { getSupportThemeClass } from '@utiles/officialSupport/theme';
export default {
  name: 'EmailSubscribe',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: undefined
    },
    submitTip: {
      type: String,
      default: ''
    },
    submitSuccessTip: {
      type: String,
      default: ''
    },

    loadingSubmit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      visibleEmailInput: false, // 是否显示邮箱输入框
      visibleEmailConfirm: false, // 是否显示邮箱确认
      visibleEmailUnSubscribe: false, // 是否显示取消订阅
      visibleEmailSubscribeSucc: false, // 是否订阅成功
      visibleEmailUnSubscribeSucc: false, // 是否取消订阅成功
      workEmail: undefined
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages
    }),
    themeClass() {
      return getSupportThemeClass(globalConfig.getHrefParam('gameId'));
    }
  },
  methods: {
    getInputEmail(val) {
      this.$emit('getInputEmail', val);
    },
    close() {
      this.visible = false;
    },
    onClosed() {
      this.$emit('change', false);
      this.resetSheet();
      this.$emit('closed');
    },
    resetSheet() {
      this.visibleEmailInput = false;
      this.visibleEmailConfirm = false;
      this.visibleEmailUnSubscribe = false;
      this.visibleEmailSubscribeSucc = false;
      this.visibleEmailUnSubscribeSucc = false;
      this.workEmail = undefined;
      this.visible = false;
    },
    showEmailInput() {
      this.visibleEmailInput = true;
      this.visibleEmailConfirm = false;
      this.visibleEmailUnSubscribe = false;
      this.visibleEmailSubscribeSucc = false;
      this.visibleEmailUnSubscribeSucc = false;
      this.visible = true;
    },
    showEmailConfirm() {
      this.visibleEmailInput = false;
      this.visibleEmailConfirm = true;
      this.visibleEmailUnSubscribe = false;
      this.visibleEmailSubscribeSucc = false;
      this.visibleEmailUnSubscribeSucc = false;
      this.visible = true;
    },
    showEmailUnSubscribe() {
      this.visibleEmailInput = false;
      this.visibleEmailConfirm = false;
      this.visibleEmailUnSubscribe = true;
      this.visibleEmailSubscribeSucc = false;
      this.visibleEmailUnSubscribeSucc = false;
      this.visible = true;
    },
    showEmailSubscribeSucc() {
      this.visibleEmailInput = false;
      this.visibleEmailConfirm = false;
      this.visibleEmailUnSubscribe = false;
      this.visibleEmailSubscribeSucc = true;
      this.visibleEmailUnSubscribeSucc = false;
      this.visible = true;
    },
    showEmailUnSubscribeSucc() {
      this.visibleEmailInput = false;
      this.visibleEmailConfirm = false;
      this.visibleEmailUnSubscribe = false;
      this.visibleEmailSubscribeSucc = false;
      this.visibleEmailUnSubscribeSucc = true;
      this.visible = true;
    },
    beforeSubmit() {
      this.showEmailConfirm();
    },
    submit() {
      this.$emit('submit');
    }
  },
  created() {
    this.visible = this.value;
    // TODO:
    // this.showEmailInput();
    // this.showEmailConfirm();
    // this.showEmailUnSubscribe();
    // this.showEmailSubscribeSucc();
    // this.showEmailUnSubscribeSucc();
  }
};
</script>

<style lang="scss" scoped>
.sheet {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 22px 17px;
  height: 296px;
  background-color: var(--block-bg-light-color);

  p {
    line-height: 24px;
  }

  &-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    height: 100%;
    font-size: 18px;
    text-align: center;
    &-title {
      margin-bottom: 23px;
      color: var(--main-color);
    }
    &-tip {
      margin-bottom: 23px;
    }
    &-main {
      width: 372px;
    }
    &-item {
      margin: 0 auto 23px;
      background-color: #ededed;
      border-radius: 6px;
      font-size: 18px;

      &::after {
        display: none;
      }

      ::v-deep .van-field__control {
        text-align: center;
      }
    }
    &-submit {
      height: 50px;
      background-color: var(--main-color);
      border: 0;
      border-radius: 6px;
      font-size: 18px;
      color: var(--text-on-main-bg-color);
    }
  }

  &-email {
    &-top {
      margin-bottom: 49px;
      > p {
        margin-bottom: 23px;
        text-align: center;
        font-size: 18px;
        &.email {
          font-weight: bold;
          color: var(--main-color);
        }
      }
    }

    &-bottom {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 48px;

      .cancel,
      .confirm {
        width: 120px;
        height: 50px;
        border-radius: 6px;
        border: 0;
        font-size: 18px;
      }

      .cancel {
        background-color: var(--menu-item-top-bgColor);
        color: var(--main-color);
      }
      .confirm {
        background-color: var(--main-color);
        color: var(--had-bg-textColor);
      }
    }
  }

  &-success {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    &-icon {
      flex-shrink: 0;
      position: relative;
      width: 48px;
      height: 48px;
      background-color: var(--main-color);
      border-radius: 50%;

      .iconfont {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: 100%;
        font-size: 24px;
        line-height: 48px;
        text-align: center;
        color: var(--text-on-main-bg-color);
        transform: scale(0.8);
      }
    }
    &-text {
      font-size: 18px;
      line-height: 24px;
      color: var(--main-color);
    }
  }

  /* 暗黑：输入框提亮，输入字色白色 */
  &.dark {
    background-color: #2c2d2f;

    .sheet-form-title {
      color: #ffffff;
    }

    .sheet-form-tip {
      color: #c0c2c9;
    }

    .sheet-form-item {
      background-color: #45474a;
      color: #ffffff;

      ::v-deep .van-field__control {
        color: #ffffff;

        &::placeholder {
          color: #949494;
        }
      }

      ::v-deep .van-field__clear {
        color: #c0c2c9;
      }
    }

    .sheet-form-submit {
      background: linear-gradient(180deg, #c14f68 0%, #9e3a50 100%);
      color: #ffffff;
    }

    .sheet-email-top > p {
      color: #ffffff;

      &.email {
        color: #ffffff;
      }
    }

    .sheet-email-bottom {
      .cancel {
        background-color: #45474a;
        color: #ffffff;
      }

      .confirm {
        background-color: #616161;
        color: #ffffff;
      }
    }

    .sheet-success-text {
      color: #ffffff;
    }
  }
}
</style>
